import {
  AppBar,
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Theme,
  Toolbar,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import makeStyles from "@mui/styles/makeStyles";
import { setWorkspaceIdSelected } from "developer/formsCRUD/store/formDefinitionsSlice";
import { Workspace } from "developer/workspaces/model";
import { useAppDispatch } from "store/hooks";

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    minWidth: 200,
  },
}));

type FormsCrudToolbarProps = {
  workspaces: Workspace[];
  workspaceIdSelected: string;
  onClickCreateForm: () => void;
};

const FormsCrudToolbar = ({
  workspaces,
  workspaceIdSelected,
  onClickCreateForm,
}: FormsCrudToolbarProps) => {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  return (
    <Box sx={{ borderBottom: `1px solid ${grey["300"]}` }} flexGrow={1}>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" component="div">
              Form Definitions
            </Typography>
          </Box>
          <Box>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <FormControl variant="standard">
                  <Select
                    labelId="select-standard-label"
                    id="select-standard"
                    value={workspaceIdSelected}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                    className={classes.select}
                    onChange={(event: any) =>
                      dispatch(setWorkspaceIdSelected(event.target.value))
                    }
                  >
                    <MenuItem value="">All</MenuItem>
                    {workspaces.map((item) => (
                      <MenuItem key={item.id} value={item.id!}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disableElevation
                  onClick={onClickCreateForm}
                >
                  New
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default FormsCrudToolbar;
